import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import ALL_SECTIONS from "common/routes/sections/all.sections";
import { SECTION_OVERVIEW } from "common/routes/sections/main.sections";

function getSection(pathname) {
  const key = [...ALL_SECTIONS.keys()].filter((pattern) =>
    new RegExp(pattern).test(pathname),
  )[0];

  return ALL_SECTIONS.get(key);
}

function useSection() {
  const location = useLocation();

  return useMemo(() => {
    const section = getSection(location.pathname);
    if (section === undefined) {
      return SECTION_OVERVIEW;
    }
    return section;
  }, [location]);
}

export default useSection;
